import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const TechTraining = () => {
  return (
    <div className="tech-training-page">
      {/* Hero Section */}
      <HeroSection />

      {/* Images for vibes */}
       <ImageSection />

       {/* Programs Section */}
      <ProgramsSection />

      {/* Why Choose Our Training */}
      <WhyChooseSection />
      
      {/* Learning Path */}
      <LearningPathSection />
      
      {/* Success Stories */}
      <SuccessStoriesSection />
      
      {/* Certifications */}
      <CertificationsSection />
      
      {/* FAQ Section */}
      <FAQSection />
      
      {/* CTA Section */}
      <CTASection />
    </div>
  );
};
// Hero Section
const HeroSection = () => {
  return (
    <section 
      className="relative py-16 overflow-hidden"
      style={{
        background: '#1e3a8a'
      }}
    >
      {/* Hexagonal Network Pattern Overlay */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='87' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25 0l25 14.4v28.8L25 57.6 0 43.2V14.4L25 0zm0 5.8L5.8 16.7v21.8L25 49.4l19.2-10.9V16.7L25 5.8z' fill='%23fff'/%3E%3Ccircle cx='25' cy='0' r='3' fill='%23fff'/%3E%3Ccircle cx='50' cy='14.4' r='3' fill='%23fff'/%3E%3Ccircle cx='50' cy='43.2' r='3' fill='%23fff'/%3E%3Ccircle cx='25' cy='57.6' r='3' fill='%23fff'/%3E%3Ccircle cx='0' cy='43.2' r='3' fill='%23fff'/%3E%3Ccircle cx='0' cy='14.4' r='3' fill='%23fff'/%3E%3C/svg%3E")`,
          backgroundSize: '100px 87px',
          backgroundRepeat: 'repeat'
        }}
      />

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-4">
          <p className="text-green-500 text-sm font-bold uppercase tracking-wider mb-4">
            CTRL YOUR FUTURE
          </p>
        </div>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 text-center leading-tight">
          Tech Training & <span className="text-green-500">Certification Programs</span>
        </h1>
        
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto text-center">
          Transform your career with hands-on training, expert guidance, and industry-recognized certifications. 
          Break into tech with Plexgate's comprehensive training programs.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {/* <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-green-500 text-white px-8 py-3 rounded-full hover:bg-green-600 transition-colors font-medium"
          >
            Enroll Now →
          </Link> */}
          {/* <a
            href="#programs"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-8 py-3 rounded-full hover:bg-white hover:text-blue-900 transition-colors font-medium"
          >
            Explore Programs
          </a> */}
        </div>
      </div>
    </section>
  );
};

// Why Choose Our Training
const WhyChooseSection = () => {
  const benefits = [
    {
      icon: '🎯',
      title: 'Hands-On Learning',
      description: 'Real-world projects and practical exercises to build your portfolio and confidence.'
    },
    {
      icon: '👨‍🏫',
      title: 'Expert Instructors',
      description: 'Learn from industry professionals with years of real-world experience.'
    },
    {
      icon: '📜',
      title: 'Industry Certifications',
      description: 'Prepare for and earn recognized certifications from Google, Microsoft, CompTIA, and more.'
    },
    {
      icon: '💼',
      title: 'Career Support',
      description: 'Resume building, interview prep, and job placement assistance to launch your tech career.'
    },
    {
      icon: '⏰',
      title: 'Flexible Schedule',
      description: 'Evening and weekend classes available to fit your lifestyle and commitments.'
    },
    {
      icon: '🤝',
      title: 'Lifetime Access',
      description: 'Ongoing support, resources, and community access even after program completion.'
    }
  ];

  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-blue-600">Plexgate Training</span>
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            We don't just teach theory—we prepare you for real tech careers with practical skills, 
            industry certifications, and ongoing support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="text-5xl mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};


// Programs Section
const ProgramsSection = () => {
  const [selectedProgram, setSelectedProgram] = useState(null);

  const programs = [
    {
      id: 1,
      title: 'Technical Support Analyst',
      slug: 'technical-support',
      duration: '5 Weeks',
      level: 'Beginner to Intermediate',
      icon: '🛠️',
      color: 'blue',
      description: 'Launch your IT career with comprehensive technical support training. Learn troubleshooting, customer service, and essential IT support skills.',
      highlights: [
        'Hardware & Software Troubleshooting',
        'Windows & macOS Support',
        'Help Desk Best Practices',
        'Remote Support Tools',
        'Ticketing Systems',
        'Customer Service Excellence',
        'Active Directory Basics',
        'Network Fundamentals'
      ],
      certifications: [
        'CompTIA A+ Preparation',
        'Google IT Support Professional Certificate',
        'Microsoft Certified: Modern Desktop Administrator Associate'
      ],
      schedule: 'Mon/Wed/Fri Evenings or Weekend Intensive',
      price: 'Contact for Pricing',
      careers: ['IT Support Specialist', 'Help Desk Technician', 'Technical Support Analyst', 'Desktop Support Technician']
    },
    {
      id: 2,
      title: 'Web Design',
      slug: 'web-design',
      duration: '8 Weeks',
      level: 'Beginner to Advanced',
      icon: '🎨',
      color: 'blue',
      description: 'Master modern web design with HTML5, CSS3, JavaScript, and responsive design principles. Build stunning, professional websites from scratch.',
      highlights: [
        'HTML5 & CSS3 Fundamentals',
        'Responsive Web Design',
        'JavaScript & jQuery',
        'React Basics',
        'UI/UX Design Principles',
        'Bootstrap & Tailwind CSS',
        'Web Accessibility',
        'Git & Version Control',
        'Portfolio Development'
      ],
      certifications: [
        'Google UX Design Certificate',
        'Meta Front-End Developer Certificate',
        'freeCodeCamp Responsive Web Design'
      ],
      schedule: 'Tue/Thu Evenings or Saturday Full Day',
      price: 'Contact for Pricing',
      careers: ['Web Designer', 'Front-End Developer', 'UI Designer', 'Freelance Web Developer']
    },
    {
      id: 3,
      title: 'Graphic Design',
      slug: 'graphic-design',
      duration: '6 Weeks',
      level: 'Beginner to Intermediate',
      icon: '🖌️',
      color: 'blue',
      description: 'Unleash your creativity with industry-standard design tools. Learn Adobe Creative Suite and design principles to create professional graphics.',
      highlights: [
        'Adobe Photoshop Mastery',
        'Adobe Illustrator Essentials',
        'Adobe InDesign Basics',
        'Color Theory & Typography',
        'Logo Design',
        'Brand Identity Creation',
        'Print & Digital Design',
        'Portfolio Building',
        'Client Management'
      ],
      certifications: [
        'Adobe Certified Professional (ACP)',
        'Canva Design Certificate',
        'Google Digital Marketing & E-commerce Certificate'
      ],
      schedule: 'Mon/Wed Evenings or Sunday Full Day',
      price: 'Contact for Pricing',
      careers: ['Graphic Designer', 'Brand Designer', 'Marketing Designer', 'Freelance Designer']
    },
    {
      id: 4,
      title: 'System Administration',
      slug: 'system-administration',
      duration: '10 Weeks',
      level: 'Intermediate to Advanced',
      icon: '⚙️',
      color: 'blue',
      description: 'Become a systems expert with comprehensive training in Windows and Linux server administration, networking, and cloud infrastructure.',
      highlights: [
        'Windows Server Administration',
        'Linux System Administration',
        'Active Directory Management',
        'Network Configuration & Security',
        'Cloud Services (AWS/Azure)',
        'Virtualization (VMware/Hyper-V)',
        'PowerShell Scripting',
        'Backup & Disaster Recovery',
        'Monitoring & Performance Tuning'
      ],
      certifications: [
        'Microsoft Certified: Windows Server Hybrid Administrator',
        'CompTIA Server+',
        'Linux Professional Institute Certification (LPIC-1)',
        'AWS Certified SysOps Administrator'
      ],
      schedule: 'Tue/Thu Evenings or Saturday/Sunday',
      price: 'Contact for Pricing',
      careers: ['System Administrator', 'Network Administrator', 'Cloud Administrator', 'DevOps Engineer']
    },
    {
      id: 5,
      title: 'Data Analyst',
      slug: 'data-analyst',
      duration: '10 Weeks',
      level: 'Beginner to Advanced',
      icon: '📊',
      color: 'blue',
      description: 'Master data analysis with hands-on training in data visualization, statistical analysis, and business intelligence. Learn to transform raw data into actionable insights.',
      highlights: [
        'Excel Advanced Techniques',
        'SQL & Database Querying',
        'Power BI & Tableau',
        'Python for Data Analysis',
        'Data Cleaning & Preparation',
        'Statistical Analysis',
        'Data Visualization',
        'Business Intelligence',
        'Dashboard Creation',
        'Reporting & Storytelling'
      ],
      certifications: [
        'Microsoft Certified: Power BI Data Analyst Associate',
        'Google Data Analytics Professional Certificate',
        'Tableau Desktop Specialist',
        'IBM Data Analyst Professional Certificate'
      ],
      schedule: 'Mon/Wed/Fri Evenings or Weekend Intensive',
      price: 'Contact for Pricing',
      careers: ['Data Analyst', 'Business Intelligence Analyst', 'Business Analyst', 'Data Visualization Specialist']
    },
    {
      id: 6,
      title: 'Web Development (E-commerce Focus)',
      slug: 'web-development-ecommerce',
      duration: '12 Weeks',
      level: 'Intermediate to Advanced',
      icon: '🛒',
      color: 'blue',
      description: 'Build professional e-commerce websites using modern CMS platforms and frameworks. Learn to create online stores with payment integration, inventory management, and customer experience optimization.',
      highlights: [
        'WordPress & WooCommerce Development',
        'Shopify Theme Customization',
        'Payment Gateway Integration',
        'Shopping Cart Development',
        'Product Management Systems',
        'SEO for E-commerce',
        'Responsive E-commerce Design',
        'CRM Integration (Salesforce, HubSpot)',
        'Inventory Management',
        'Analytics & Conversion Optimization',
        'Security & PCI Compliance'
      ],
      certifications: [
        'Shopify Partner Academy',
        'WooCommerce Certification',
        'Google Analytics for E-commerce',
        'Meta Blueprint Certification'
      ],
      schedule: 'Tue/Thu/Sat or Weekend Intensive',
      price: 'Contact for Pricing',
      careers: ['E-commerce Developer', 'Shopify Developer', 'Web Developer', 'Digital Commerce Specialist']
    },
    {
      id: 7,
      title: 'Application Development',
      slug: 'application-development',
      duration: '14 Weeks',
      level: 'Intermediate to Advanced',
      icon: '💻',
      color: 'blue',
      description: 'Become a full-stack application developer with comprehensive training in modern frameworks, databases, and deployment. Build scalable web and mobile applications from concept to production.',
      highlights: [
        'JavaScript & TypeScript',
        'React & React Native',
        'Node.js & Express',
        'Python & Django/Flask',
        'RESTful API Development',
        'MongoDB & PostgreSQL',
        'Git & GitHub Workflows',
        'Authentication & Security',
        'Testing & Debugging',
        'AWS/Azure Deployment',
        'Docker & Containerization',
        'Agile Development Practices'
      ],
      certifications: [
        'Meta Front-End Developer Professional Certificate',
        'Meta Back-End Developer Professional Certificate',
        'AWS Certified Developer Associate',
        'Microsoft Certified: Azure Developer Associate'
      ],
      schedule: 'Mon/Wed/Fri Evenings or Full Weekend',
      price: 'Contact for Pricing',
      careers: ['Full-Stack Developer', 'Application Developer', 'Software Engineer', 'Mobile App Developer']
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-100 text-blue-600 border-blue-200'
    };
    return colors[color] || colors.blue;
  };

  return (
    <section id="programs" className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-blue-600 font-bold uppercase tracking-wider mb-2">Our Programs</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Explore Our <span className="text-blue-600">Training Programs</span>
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Choose from our carefully designed programs to start or advance your tech career. 
            Each program includes hands-on training, certification prep, and career support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {programs.map((program) => (
            <div
              key={program.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow cursor-pointer"
              onClick={() => setSelectedProgram(selectedProgram === program.id ? null : program.id)}
            >
              {/* Program Header */}
              <div className={`p-6 ${getColorClasses(program.color)} border-b-4`}>
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-5xl mb-3">{program.icon}</div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{program.title}</h3>
                    <div className="flex flex-wrap gap-2">
                      <span className="bg-white px-3 py-1 rounded-full text-sm font-medium">
                        {program.duration}
                      </span>
                      <span className="bg-white px-3 py-1 rounded-full text-sm font-medium">
                        {program.level}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Program Content */}
              <div className="p-6">
                <p className="text-gray-600 mb-6">{program.description}</p>

                {/* Expandable Details */}
                {selectedProgram === program.id && (
                  <div className="space-y-6 animate-fadeIn">
                    {/* What You'll Learn */}
                    <div>
                      <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        📚 What You'll Learn
                      </h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        {program.highlights.map((item, idx) => (
                          <div key={idx} className="flex items-start gap-2">
                            <span className="text-blue-500 mt-1">✓</span>
                            <span className="text-sm text-gray-600">{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Certifications */}
                    <div>
                      <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        🎓 Certification Preparation
                      </h4>
                      <ul className="space-y-2">
                        {program.certifications.map((cert, idx) => (
                          <li key={idx} className="text-sm text-gray-600 flex items-start gap-2">
                            <span className="text-blue-500">→</span>
                            {cert}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Career Paths */}
                    <div>
                      <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        💼 Career Opportunities
                      </h4>
                      <div className="flex flex-wrap gap-2">
                        {program.careers.map((career, idx) => (
                          <span key={idx} className="bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-700">
                            {career}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Schedule & Price */}
                    <div className="border-t pt-4">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-sm text-gray-600">📅 Schedule:</span>
                        <span className="text-sm font-medium text-gray-900">{program.schedule}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">💰 Investment:</span>
                        <span className="text-sm font-medium text-gray-900">{program.price}</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                <div className="flex gap-3 mt-6">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedProgram(selectedProgram === program.id ? null : program.id);
                    }}
                    className="flex-1 border-2 border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:border-gray-400 transition-colors font-medium text-sm"
                  >
                    {selectedProgram === program.id ? 'Show Less' : 'Learn More'}
                  </button>
                  <Link
                    to={`/enroll/${program.slug}`}
                    className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm text-center"
                  >
                    Enroll Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
const ImageSection = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Transform Your Career with <span className="text-blue-600">Expert-Led Training</span>
            </h2>
            <p className="text-gray-600 mb-6 text-lg">
              Join thousands of professionals who have successfully transitioned into tech careers 
              through our comprehensive, hands-on training programs.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 rounded-full p-2 mt-1">
                  <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Interactive Live Classes</h3>
                  <p className="text-gray-600">Learn directly from industry experts in real-time sessions</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 rounded-full p-2 mt-1">
                  <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Real-World Projects</h3>
                  <p className="text-gray-600">Build a professional portfolio with practical assignments</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 rounded-full p-2 mt-1">
                  <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Career Support</h3>
                  <p className="text-gray-600">Get guidance from enrollment to job placement</p>
                </div>
              </div>
            </div>
            <div className="mt-8">
            </div>
          </div>

          {/* Image with Decorative Blobs */}
          <div className="relative">
            {/* Decorative Blob - Bottom Left (Blue) */}
            <div className="absolute -bottom-8 -left-8 w-48 h-48 bg-blue-500 rounded-full opacity-80 blur-3xl z-0"></div>
            
            {/* Decorative Blob - Top Right (Purple/Pink) */}
            <div className="absolute -top-8 -right-8 w-40 h-40 bg-pink-500 rounded-full opacity-70 blur-3xl z-0"></div>
            
            {/* Image Container */}
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80"
                alt="Students learning together"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

/// Learning Path Section
const LearningPathSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Enrollment & Assessment',
      description: 'Complete your enrollment and take an initial skills assessment to customize your learning path.',
      icon: (
        <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      )
    },
    {
      number: '02',
      title: 'Structured Learning',
      description: 'Follow our comprehensive curriculum with live classes, hands-on labs, and real-world projects.',
      icon: (
        <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
        </svg>
      )
    },
    {
      number: '03',
      title: 'Practice & Build',
      description: 'Apply your skills through practical exercises, capstone projects, and portfolio development.',
      icon: (
        <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
          <circle cx="9" cy="9" r="1" />
          <circle cx="12" cy="9" r="1" />
          <circle cx="15" cy="9" r="1" />
          <line x1="7" y1="13" x2="17" y2="13" />
        </svg>
      )
    },
    {
      number: '04',
      title: 'Certification Prep',
      description: 'Prepare for industry-recognized certifications with practice exams and expert guidance.',
      icon: (
        <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
          <path d="M8 12h8" />
          <path d="M12 8v8" />
        </svg>
      )
    },
    {
      number: '05',
      title: 'Career Launch',
      description: 'Get job-ready with resume reviews, interview prep, and access to our hiring network.',
      icon: (
        <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="7.5 4.21 12 6.81 16.5 4.21" />
          <polyline points="7.5 19.79 7.5 14.6 3 12" />
          <polyline points="21 12 16.5 14.6 16.5 19.79" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      )
    }
  ];

  return (
    <section 
      className="py-16 relative"
      style={{
        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)), url("https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1200&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Your <span className="text-blue-600">Learning Journey</span>
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            We guide you every step of the way from enrollment to career placement
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-blue-200 transform -translate-y-1/2" style={{ zIndex: 0 }} />

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 relative" style={{ zIndex: 1 }}>
            {steps.map((step, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="bg-blue-600 text-white w-24 h-24 rounded-full flex items-center justify-center mb-4 shadow-lg">
                  {step.icon}
                </div>
                <div className="bg-blue-100 text-blue-700 font-bold px-4 py-1 rounded-full mb-3 text-sm">
                  STEP {step.number}
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-sm text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Success Stories Section
const SuccessStoriesSection = () => {
  const stories = [
    {
      name: 'Cherish Oluehi.',
      program: 'Technical Support Analyst',
      before: 'administrative Assistant',
      after: 'IT Support Specialist at Bank',
      image: '/images/student1.jpg',
      quote: 'The 5-week program gave me all the skills I needed to transition into IT. Within 2 months of graduation, I landed my first tech job!',
      salary: '$65,000/year',
     image: '/images/profile.png'
    },
    {
      name: 'Marcus Travis.',
      program: 'Web Design',
      before: 'Unemployed Graduate',
      after: 'Freelance Web Designer',
      image: '/images/student2.jpg',
      quote: 'I went from zero coding knowledge to building professional websites. Now I have multiple clients and love what I do!',
      salary: '$40,000/year freelance',
      image: 'https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=150&h=150&fit=crop&crop=faces'
    },
    {
      name: 'Henry Smith.',
      program: 'System Administration',
      before: 'Junior IT Support',
      after: 'Systems Administrator at Fortune 500',
      image: '/images/student3.jpg',
      quote: 'This program took my career to the next level. The hands-on labs and certification prep were invaluable.',
      salary: '$95,000/year',
      image: 'https://images.unsplash.com/photo-1600180758890-6b94519a8ba6?w=150&h=150&fit=crop&crop=faces'



    }
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            <span className="text-green-600">Success Stories</span> From Our Graduates
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Real people, real career transformations. See how our training programs have helped others achieve their tech career goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stories.map((story, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-gray-300 rounded-full mr-4 overflow-hidden">
                  <img
                    src={story.image}
                    alt={story.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = '<div class="w-16 h-16 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">' + story.name.charAt(0) + '</div>';
                    }}
                  />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">{story.name}</h3>
                  <p className="text-sm text-green-600 font-medium">{story.program}</p>
                </div>
              </div>

              <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm text-gray-500">Before:</span>
                  <span className="text-sm font-medium text-gray-700">{story.before}</span>
                </div>
                <div className="flex items-center justify-center my-2">
                  <span className="text-green-500 text-2xl">↓</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">After:</span>
                  <span className="text-sm font-medium text-green-600">{story.after}</span>
                </div>
              </div>

              <p className="text-gray-600 italic mb-4">"{story.quote}"</p>

              <div className="bg-green-100 text-green-700 px-4 py-2 rounded-lg text-center font-bold">
                💰 {story.salary}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Certifications Section
const CertificationsSection = () => {
  const certifications = [
    { name: 'CompTIA Certified', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Comptia-logo.svg/440px-Comptia-logo.svg.png' },
    { name: 'Google IT Support', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg' },
    { name: 'Microsoft Certified', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg' },
    { name: 'AWS Certified', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg' },
    { name: 'Adobe Certified', logo: 'https://upload.wikimedia.org/wikipedia/commons/6/6e/Adobe_Corporate_logo.svg' },
    { name: 'Linux Professional', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg' },
    { name: 'Azure Professional', logo: 'https://logos-world.net/wp-content/uploads/2021/05/Azure-Logo.png' }
  ];

  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Industry-Recognized <span className="text-green-600">Certifications</span>
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Our programs prepare you for the most valuable certifications in the industry
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {certifications.map((cert, index) => (
            <div key={index} className="flex flex-col items-center justify-center p-4 bg-gray-50 rounded-lg hover:shadow-lg transition-shadow">
              <img src={cert.logo} alt={cert.name} className="h-16 w-auto object-contain mb-2" />
              <span className="text-sm text-gray-600 text-center font-medium">{cert.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// FAQ Section
const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      question: 'Do I need prior experience to enroll?',
      answer: 'No! Our programs are designed for beginners and those looking to advance their skills. We start with fundamentals and build up to advanced topics. Each program clearly indicates the prerequisite level.'
    },
    {
      question: 'What is the class format?',
      answer: 'We offer a hybrid approach with live online classes, recorded sessions for review, hands-on labs, and real-world projects. Classes are conducted in small groups to ensure personalized attention.'
    },
    {
      question: 'How much time do I need to commit?',
      answer: 'Depending on the program, expect to commit 10-15 hours per week including class time, homework, and practice. We offer flexible schedules with evening and weekend options to fit your lifestyle.'
    },
    {
      question: 'Do you offer job placement assistance?',
      answer: 'Yes! We provide comprehensive career support including resume reviews, portfolio development, interview preparation, and connections to our hiring partner network.'
    },
    {
      question: 'Are payment plans available?',
      answer: 'Yes, we offer flexible payment plans to make our programs accessible. Contact us to discuss options that work for your budget.'
    },
    {
      question: 'What happens after I complete the program?',
      answer: 'You receive a certificate of completion, lifetime access to course materials, ongoing career support, and access to our alumni network and community.'
    }
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked <span className="text-green-600">Questions</span>
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              <button
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span className="font-bold text-gray-900">{faq.question}</span>
                <span className="text-green-600 text-2xl">
                  {openFAQ === index ? '−' : '+'}
                </span>
              </button>
              {openFAQ === index && (
                <div className="px-6 py-4 bg-gray-50 border-t">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// CTA Section
const CTASection = () => {
  return (
    <section 
      className="py-16"
      style={{
        background: '#1e3a8a'
      }}
    >
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Start Your <span className="text-green-500">Tech Career?</span>
        </h2>
        <p className="text-xl text-gray-300 mb-8">
          Join hundreds of successful graduates who have transformed their careers with Plexgate training programs.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-green-500 text-white px-8 py-4 rounded-full hover:bg-green-600 transition-colors font-medium text-lg"
          >
            Schedule a Free Consultation →
          </Link>
          <a
            href="tel:+1234567890"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-blue-900 transition-colors font-medium text-lg"
          >
            📞 Call Us Now
          </a>
        </div>

        <p className="text-gray-400 mt-8">
          🎓 Limited seats available | 💼 Job placement assistance included | ⏰ Flexible schedules
        </p>
      </div>
    </section>
  );
};

export default TechTraining;